import { createClient } from '@supabase/supabase-js'

// Determine if we're in development mode and should use local environment
const isLocalDev = process.env.NODE_ENV === 'development' && 
                   window.location.hostname === 'localhost'

// Use local or production Supabase URL and key
const supabaseUrl = isLocalDev 
  ? 'http://127.0.0.1:54321'  
  : process.env.REACT_APP_SUPABASE_URL

const supabaseAnonKey = isLocalDev
  ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0'
  : process.env.REACT_APP_SUPABASE_ANON_KEY

if (isLocalDev) {
  console.log('Using local Supabase instance:', supabaseUrl)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  }
})